import { AnimationComponent, Box, Grid2, Show, Tab, Tabs } from "components";
import DashboardLayout from "layouts/DashboardLayout";
import { filter, map } from "lodash";
import {
  Automation,
  CommissionManager,
  Coupon,
  FeeCalculation,
  FeeCollection,
  FeePlan,
  Invoice,
  Mandate,
  Proforma,
  RevenueManager,
} from "Pages/Revenue";
import PaymentLinkModal from "Pages/Revenue/PaymentLinks";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { AccountType, UserRoleTypes } from "utils/common";
import useDocumentTitle from "utils/useDocumentTitle";

const Revenue = () => {
  useDocumentTitle("Revenue");

  const dispatch = useAppDispatch();

  const user = useAppSelector((state) => state?.user?.userData);
  const { tabValueOfRevenue } = useAppSelector((state) => state?.app?.tab);

  const tabs = [
    {
      label: "Revenue Manager",
      component: <RevenueManager />,
      show: [UserRoleTypes.advisor, UserRoleTypes.partner],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Fee Plan Setup",
      component: <FeePlan />,
      show: [UserRoleTypes.advisor],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Coupon",
      component: <Coupon />,
      show: [UserRoleTypes.advisor, UserRoleTypes.partner],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Fee Calculation",
      show: [UserRoleTypes.advisor],
      component: <FeeCalculation />,
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Proforma",
      component: <Proforma />,
      show: [
        UserRoleTypes.advisor,
        UserRoleTypes.client,
        UserRoleTypes.partner,
      ],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Invoice",
      component: <Invoice />,
      show: [
        UserRoleTypes.advisor,
        UserRoleTypes.client,
        UserRoleTypes.partner,
      ],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Fee Collection",
      component: <FeeCollection />,
      show: [
        UserRoleTypes.advisor,
        UserRoleTypes.client,
        UserRoleTypes.partner,
      ],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Mandate",
      component: <Mandate />,
      show: [UserRoleTypes.advisor],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Payment Links",
      component: <PaymentLinkModal />,
      show: [UserRoleTypes.advisor],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.RA,
        AccountType.ONLY_ONBOARDING,
      ],
    },
    {
      label: "Commission Manager",
      show: [UserRoleTypes.advisor],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.ONLY_ONBOARDING,
      ],
      component: <CommissionManager />,
    },
    {
      label: "Automation",
      show: [UserRoleTypes.advisor],
      accountType: [
        AccountType.RA_RIA,
        AccountType.RIA,
        AccountType.ONLY_ONBOARDING,
      ],
      component: <Automation />,
    },
  ];

  const filteredTabs = tabs.filter((tab) => tab.show.includes(user?.userRole));

  return (
    <DashboardLayout title="Revenue">
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              sx={{
                "& .MuiTabs-flexContainer": { backgroundColor: "var(--white)" },
              }}
              onChange={(e, val) => {
                dispatch(TAB({ tabKey: "tabValueOfRevenue", tabValue: val }));
              }}
              value={tabValueOfRevenue}
              variant="scrollable"
              scrollButtons={false}
            >
              {map(
                filter(filteredTabs, (tab) =>
                  tab?.accountType?.includes(user?.accountType),
                ),
                (tab, index) => (
                  <Tab key={index} label={tab.label} disableTouchRipple />
                ),
              )}
            </Tabs>
          </Box>
        </Grid2>
        <Grid2 size={12}>
          {map(
            filter(filteredTabs, (tab) =>
              tab?.accountType?.includes(user?.accountType),
            ),
            (tab, index) => (
              <Show.When key={index} isTrue={tabValueOfRevenue === index}>
                <AnimationComponent>{tab?.component}</AnimationComponent>
              </Show.When>
            ),
          )}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default Revenue;
